import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SituationInputForm = ({ formData, onChange }) => {
  const stageOptions = [
    { value: 'cold-outreach', label: 'Cold Outreach' },
    { value: 'follow-up', label: 'Follow-up' },
    { value: 'discovery', label: 'Discovery Call' },
    { value: 'proposal', label: 'Proposal Stage' },
    { value: 'negotiation', label: 'Negotiation' },
    { value: 'closing', label: 'Closing' }
  ];

  const handleChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground">Lead Situation Details</h3>
      <Input
        label="Prospect Name"
        type="text"
        placeholder="e.g., Sarah Johnson"
        value={formData?.prospectName}
        onChange={(e) => handleChange('prospectName', e?.target?.value)}
        required
      />
      <Select
        label="Sales Stage"
        options={stageOptions}
        value={formData?.stage}
        onChange={(value) => handleChange('stage', value)}
        placeholder="Select current stage"
        required
      />
      <Input
        label="Prospect Background"
        type="text"
        placeholder="e.g., Small business owner, 5 employees, looking to expand"
        value={formData?.background}
        onChange={(e) => handleChange('background', e?.target?.value)}
        description="Brief context about the prospect"
      />
      <Input
        label="Previous Interactions"
        type="text"
        placeholder="e.g., Met at trade show, expressed interest in automation"
        value={formData?.interactions}
        onChange={(e) => handleChange('interactions', e?.target?.value)}
        description="Any prior communication or touchpoints"
      />
      <Input
        label="Desired Outcome"
        type="text"
        placeholder="e.g., Schedule demo call, get pricing approval"
        value={formData?.outcome}
        onChange={(e) => handleChange('outcome', e?.target?.value)}
        description="What you want to achieve with this script"
        required
      />
      <Input
        label="Key Pain Points"
        type="text"
        placeholder="e.g., Manual processes taking too much time"
        value={formData?.painPoints}
        onChange={(e) => handleChange('painPoints', e?.target?.value)}
        description="Prospect's main challenges or concerns"
      />
    </div>
  );
};

export default SituationInputForm;